import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import MuiAlert from "@material-ui/lab/Alert";
import styled from "styled-components";
import ConfirmationModal from "components/modify/ConfirmationModal";
import Typography from "@material-ui/core/Typography";
import schema from "components/modify/JsonEditorSchema";
import { readdChildrenProperty } from "utils";
import HiddenOn from "components/common/HiddenOn";

/**
 *  todo: link up actual request to the success/error snackbar
 *  also add appearing button that'll redirect them to the /event/:id page on click if successfull
 */

const Save = ({
  mission,
  ajv,
  createEvent,
  editors,
  confirmationModalText,
}) => {
  const [confirmSaveModalOpen, setConfirmSaveModalOpen] = useState(false);

  const validate = ajv.compile(schema());
  const validSchema = validate(mission);

  return (
    <>
      <Container>
        <Typography variant="h5" component="h3">
          SAVE
        </Typography>
        <HiddenOn hideOn={validSchema}>
          <Box>
            <Typography variant="h6" component="h6">
              Warnings:
            </Typography>
            <ErrorBox>
              Your mission has failed validation. Please recheck the{" "}
              <b>SCHEMA</b> tab.
            </ErrorBox>
          </Box>
        </HiddenOn>
        {/* <Box>
          <Typography variant="h6" component="h6">
            <u>Make Draft Event</u>
          </Typography>
          <div>
            When you make an event as a draft your changes will be saved but the
            event will not be viewable to the public.
            <p>
              You can always choose to publish the Event and edit at a later
              date.
            </p>
            COMING SOON
          </div>
          <Button
            id="button"
            variant="contained"
            color="secondary"
            disabled={true}
            onClick={() => {
              setConfirmSaveModalOpen(true);
            }}
          >
            Create Draft
          </Button>
        </Box> */}

        <Box>
          <Typography variant="h6" component="h6">
            <u>Publish Event</u>
          </Typography>
          <div>
            When you publish a Event it makes it immediately available to be
            viewed and slotted by players.
            {/* <p>
              You can always choose to change the Event to a draft or edit at a
              later date.
            </p> */}
          </div>
          <Button
            id="button"
            variant="contained"
            color="secondary"
            disabled={!validSchema}
            onClick={() => {
              setConfirmSaveModalOpen(true);
            }}
          >
            Publish Event
          </Button>
        </Box>
      </Container>
      <ConfirmationModal
        isOpen={confirmSaveModalOpen}
        setIsOpen={setConfirmSaveModalOpen}
        mainBodyText={confirmationModalText}
        errorText={"Box"}
        onClickYes={({ setIsOpen }) => {
          createEvent({
            ...readdChildrenProperty(mission),
            event: {
              ...mission.event,
              event_published: true,
            },
            editors: editors.map((i) => {
              return {
                username: i,
                is_owner: true,
              };
            }),
          });
          setIsOpen(false);
        }}
        onClickNo={({ setIsOpen }) => setIsOpen(false)}
      />
    </>
  );
};

const Box = styled.div`
  border: 2px solid #3f51b5;
  border-radius: 5px;
  margin: 10px;
  padding: 5px;
`;

const ErrorBox = styled.div`
  color: red;
`;

const Container = styled.div`
  width: 100%;
  background: #36393f;
  border-radius: 5px;
  padding: 10px;
`;

export function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

// const Container = styled.div`
//   display: flex;
//   flex-direction: row;
//   > div {
//     border: 1px solid white;
//     display: flex;
//     flex-direction: column;
//     margin: 10px;
//     flex-grow: 1;
//     > button {
//       margin: 10px;
//     }
//   }
//   #fixedPanels {
//     min-width: 250px;
//     max-width: 250px;
//     justify-content: space-around;
//   }
// `;

export default Save;
